import { z } from 'zod';

export const SubmitSeedingContentServiceRequestSchema = z
  .object({
    participationId: z.number().int(),
    channel: z.enum(['INSTAGRAM', 'YOUTUBE', 'TWITTER', 'TIKTOK', 'NAVER_BLOG', 'THREADS', 'SNAP']),
    contentType: z.enum(['IMAGE', 'SHORT_FORM', 'LONG_FORM', 'TEXT', 'BLOG_POST']),
    contentUrl: z.string(),
  })
  .describe('SubmitSeedingContentServiceRequest');

export type SubmitSeedingContentServiceRequest = z.infer<
  typeof SubmitSeedingContentServiceRequestSchema
>;

// 204 No Content — 반환값 없음.
export const SubmitSeedingContentServiceResponseSchema = z
  .void()
  .describe('SubmitSeedingContentServiceResponse');

export type SubmitSeedingContentServiceResponse = z.infer<
  typeof SubmitSeedingContentServiceResponseSchema
>;
